(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue"], factory);
	else if(typeof exports === 'object')
		exports["SmartTable"] = factory(require("Vue"));
	else
		root["SmartTable"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_169__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/